<template>
  <div>
    <component :is="isPc"></component>
  </div>
</template>

<script>
import isMobile from "@/common/js/utils/isMobile.js"
import PcDetail from "./components/detail/PcDetail"
import MobileDetail from "./components/detail/MobileDetail"
export default {
  props: ["powerlist"],
  name: "Detail",
  data() {
    return {
      isPc: ''
    };
  },

  created() {
    //判断当前是否为PC端还是移动端
    if(!isMobile()) {
      this.isPc = PcDetail;
    }else {
      this.isPc = MobileDetail;
    }
    
  }
};
</script>

<style scoped>
</style>

